<div class="app-page" >
  <h2>
    <mat-icon style="font-size: 36px; height: 36px; width: 36px;">assignment_turned_in</mat-icon>
    TEST PROFILES
  </h2>
  <mat-divider></mat-divider>
  <div style="display: flex; flex-wrap: wrap; ">

    @for (prof of this._profiles; track prof) {
      <app-profile-card [Profile]="prof" (deleted)="onDeleted()">
      </app-profile-card>
    }
    <section>
      @if (this._profiles.length==0) {
        <div class="aa">
          No profiles created
        </div>
      }
    </section>

    <div class="fab-container">
      <button mat-mini-fab color="primary"  routerLink="/profileadd" ><mat-icon>add</mat-icon></button>
    </div>

  </div>

</div>